import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/Login';
// import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ImpersonateBridge from './components/auth/ImpersonateBridge';
import Dashboard from './pages/dashboard/Dashboard';
import CheckoutPage from './pages/checkout/CheckoutPage';
import CollectCard3dsPage from './pages/checkout/CollectCard3dsPage';
import CheckoutEmbedPreview from './pages/checkout/CheckoutEmbedPreview';
import PaymentRedirectStatusPage from './pages/payment/PaymentRedirectStatusPage';
// import Dashboard from './components/dashboard/Dashboard';
import PublicDocsPage from './components/docs/PublicDocsPage';
// import CheckoutPage from './components/checkout/CheckoutPage';
// import PaymentRedirectStatusPage from './components/payment/PaymentRedirectStatusPage';
import PageNotFound from './components/shared/PageNotFound';
import { Toaster } from './components/ui/sonner';
import { TooltipProvider } from './components/ui/tooltip';
import { useAuthStore } from './store/authStore';
import './App.css';

function App() {
  const { isAuthenticated } = useAuthStore();
  const isMerchantUser = useAuthStore((state) => state.user?.userType) === 'MERCHANT';

  useEffect(() => {
    if (!isMerchantUser) return;

    const disableContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    document.addEventListener('contextmenu', disableContextMenu);
    return () => document.removeEventListener('contextmenu', disableContextMenu);
  }, [isMerchantUser]);

  return (
    <TooltipProvider delayDuration={300}>
      <Router>
        <Toaster />
        <Routes>
        <Route path="/login" element={<Login />} />
        {/* Merchant self-registration disabled — re-enable with Login footer link.
        <Route path="/register" element={<Register />} />
        */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/impersonate" element={<ImpersonateBridge />} />
        <Route path="/pay/3ds/:transactionId" element={<CollectCard3dsPage />} />
        <Route path="/pay/:token" element={<CheckoutPage />} />
        <Route path="/embed-preview" element={<CheckoutEmbedPreview />} />
        <Route path="/docs" element={<PublicDocsPage />} />
        <Route
          path="/payments/redirect/status/:transactionId"
          element={<PaymentRedirectStatusPage />}
        />
        <Route
          path="/dashboard/*"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/" element={<Navigate to="/dashboard/transaction-dashboard" />} />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Router>
    </TooltipProvider>
  );
}

export default App;
